import React from "react";
//#region types
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { SelfInvoiceFormGeneralSectionWizardProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import { WizardSection } from "components/common/wintForms";
import SelfInvoiceFormGeneralFields from "./generalFields";
import { Grid } from "@mui/material";
//#endregion

const SelfInvoiceFormGeneralSectionWizard: React.FC<
  SelfInvoiceFormGeneralSectionWizardProps<InvoiceFormTypes.SelfInvoice>
> = (props) => {
  const { connect, values, submitted, wizardProps } = props;

  const customerSearchProps = connect("customer");
  const invoiceDateProps = connect("invoiceDate");
  const oCRNumberProps = connect("oCRNumber");

  const hasErrors = customerSearchProps.hasError || invoiceDateProps.hasError || oCRNumberProps.hasError;

  return (
    <WizardSection
      header={TranslationKeys.Invoice.SelfInvoiceDetails}
      description={values.customer?.value ?? TranslationKeys.Invoice.ReceiverDescription}
      submitted={submitted}
      hasErrors={hasErrors}
      wizardProps={wizardProps}
    >
      <Grid container item md={5}>
        <SelfInvoiceFormGeneralFields connect={connect} />
      </Grid>
    </WizardSection>
  );
};

export default SelfInvoiceFormGeneralSectionWizard;
